import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutsideClickDirective } from './outside-click.directive';
import { XssValidationDirective } from './xss-validation.directive';
import { SplitterDirective } from './splitter.directive';
import { OutsideMousedownDirective } from './outside-mousedown.directive';
import { DomTemplateDirective } from './dom-template.directive';
import { DebounceClickDirective } from './debounce-click.directive';
import { OutsideContextMenuDirective } from './outside-contextmenu.directive';
import { VirtualGridScroll } from './virtual-grid-scroll';

const directives = [
  OutsideClickDirective,
  OutsideMousedownDirective,
  OutsideContextMenuDirective,
  XssValidationDirective,
  SplitterDirective,
  DomTemplateDirective,
  DebounceClickDirective,
  VirtualGridScroll
];

@NgModule({
  declarations: directives,
  exports: directives,
  imports: [CommonModule]
})
export class DirectivesModule {}

export {
  DebounceClickDirective,
  DomTemplateDirective,
  OutsideClickDirective,
  OutsideContextMenuDirective,
  OutsideMousedownDirective,
  SplitterDirective,
  XssValidationDirective,
  VirtualGridScroll
};
